import { createContext, useContext } from 'react'
import { Operator } from '../types'

interface AuthContextType {
  operator: Operator | null
  isLoading: boolean
  refetch: () => void
}

export const AuthContext = createContext<AuthContextType>({
  operator: null,
  isLoading: true,
  refetch: () => {},
})

export const useAuth = () => useContext(AuthContext)
